<template>
  <div class="write-comment m-wrapper m-wbox m-container-max">
    <div>
      <header>
        <div class="back-wrapper header-box" @click="back()">
          <img src="../assets/images/arrow_left.png" alt="" style="width: .5rem;height: .75rem;">
        </div>
        <div class="center-wrapper header-box">
          <!--<p>写评论</p>-->
          <p @click="isClicked = !isClicked" v-if="isMideaConnect && !hasType">
            <span style="font-size: .875rem;" v-if="isHideName">匿名</span>
            <span style="font-size: .875rem;" v-else>实名</span>
            <img src="../assets/images/arrow_down.png" alt="" style="width: .75rem;height: .375rem;margin-left: .5rem;" :class="{rotate180: isClicked, rotate0: !isClicked}"/>
          </p>
          <p v-else>
            <input type="text" class="com-input" placeholder="默认匿名评论，可设置昵称" v-model="nickname"/>
          </p>
        </div>
        <div class="right-wrapper header-box">
          <a href="javascript:void(0);" @click="send()">发送</a>
        </div>
      </header>
      <main>
        <div class="relative write-comment-div">
          <transition name="slide-fade">
            <div class="absolute choose-id-box" v-if="isClicked" @click="isClicked = !isClicked">
              <ul>
                <li @click.stop="chooseId(true)">
                  <img src="../assets/images/photo_default_icon.png" alt=""/>
                  <a href="javascript:void(0);">匿名</a>
                </li>
                <li @click.stop="chooseId(false)">
                  <img src="../assets/images/photo_default_icon.png" alt=""/>
                  <a href="javascript:void(0);">实名</a>
                </li>
              </ul>
            </div>
          </transition>
          <textarea ref="textarea" name="" id="" cols="30" rows="10" :placeholder="placeholder" style="width: 100%;" v-model="content"></textarea>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { isMideaConnect } from '../utils/utils'
export default {
  name: 'writeComment',
  data () {
    return {
      content: '',
      placeholder1: '写评论...',
      placeholder2: '回复评论...',
      isClicked: false,
      isHideName: true,
      targetType: '1',
      nickname: ''
    }
  },
  computed: {
    placeholder () {
      return this.targetType === '1' ? this.placeholder1 : this.placeholder2
    },
    isMideaConnect () {
      return isMideaConnect()
    },
    hasType () {
      return this.$route.query.type === 'h5'
    }
  },
  methods: {
    chooseId (isHideName) {
      this.isHideName = isHideName
      this.isClicked = !this.isClicked
    },
    back () {
      this.$router.go(-1)
    },
    send () {
      this.$toastMessage({ icon: 'loading', message1: '请稍候', times: 120000 })
      // this.getConfigJson()
      //   .then(() => {
      let token, userId, isThirdPartPlat
      const noTokenFlag = this.$store.getters.noTokenFlag
      if (isMideaConnect()) {
        token = this.$store.getters.token
        userId = this.$store.getters.userId
      }
      if (noTokenFlag) {
        isThirdPartPlat = true
        token = null
      } else {
        isThirdPartPlat = !isMideaConnect()
        token = this.$store.getters.token
      }
      if (!isMideaConnect()) {
        this.isHideName = true
      }
      if (this.isHideName) {
        // token = ''
        userId = ''
      }
      if (this.nickname) {
        this.isHideName = false
      }
      this.content = this.content.replace(/&/g, '%26')
      this.$store.dispatch('createCommentMxpOther', {
        isThirdPartPlat: isThirdPartPlat,
        articleId: this.$route.query.id,
        content: this.content,
        isHideName: this.isHideName,
        targetType: this.targetType,
        userName: this.nickname,
        userId: userId,
        ssoToken: token
      })
        .then(res => {
          console.log(res.data.code)
          if (res.data.code === 0) {
            this.$toastMessage({ icon: '&#xe66f;', message1: '评论提交成功，待管理员审核', times: 1000 })
            // 先审后评，这个不需要了
            // this.$store.dispatch('addCommentNum')
            setTimeout(() => {
              this.content = ''
              this.$router.go(-1)
            }, 900)
          } else {
            this.$toastMessage({ icon: '&#xe7a3;', message1: res.data.msg })
          }
        })
        // })
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$refs.textarea.focus()
    })
  },
  activated () {
    this.targetType = this.$route.query.targetType
  }
}
</script>

<style scoped>
  .write-comment {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    overflow: hidden;
  }
  header {
    position: relative;
    padding: .532rem .6rem;
    background-color: #fafafa;
    border-top-width: 0;
    border-right-width: 0;
    border-bottom-width: 1px;
    border-left-width: 0;
    border-color: #cfcfcf;
    border-style: solid;
  }
  header .back-wrapper {
    width: 3.125rem;
    height: 1.9375rem;
    position: absolute;
    left: 0;
    top: .625rem;
    text-align: center;
    line-height: 1.9375rem;
  }
  header .center-wrapper {
    width: 100%;
    height: 1.9375rem;
    padding: 0 3.5rem 0 3.5rem;
    box-sizing: border-box;
  }
  header .center-wrapper p {
    text-align: center;
    margin-block-start: 0;
    margin-block-end: 0;
    line-height: 1.9375rem;
    word-wrap: break-word;
  }
  header .right-wrapper {
    width: 6.0625rem;
    height: 2rem;
    position: absolute;
    right: 0;
    top: .5rem;
    padding: .3rem 0 0 2.4375rem;
  }
  header .right-wrapper a {
    display: block;
    width: 100%;
    height: 100%;
    text-align: center;
    text-decoration: none;
    color: #1b9af4;
  }
  main>div {
    overflow-y: hidden;
    padding: .6rem;
    height: calc(100vh - 3.5rem);
    background-color: #fff;
  }
  main>div>textarea{
    font-family: sans-serif;
    margin-top: .65625rem;
    color: #333;
    background-color: transparent;
    outline: 0;
    border: none;
    font-size: 1rem;
    resize: none;
    width: 100%;
    box-sizing: border-box;
  }
  .rotate180 {
    transform: rotate(180deg);
    transition:transform .1s linear;
  }
  .rotate0 {
    transform: rotate(0deg);
    transition:transform .1s linear;
  }
  .relative {
    position: relative;
  }
  .absolute {
    position: absolute;
  }
  .choose-id-box {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: rgba(0,0,0,.5);
  }
  .choose-id-box>ul {
    display: flex;
    justify-content: space-around;
    width: 100%;
    background-color: #fff;
  }
  .choose-id-box>ul>li {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 1rem;
  }
  .choose-id-box>ul>li>img {
    width: 2rem;
    height: 2rem;
  }
  .choose-id-box>ul>li>a {
    font-size: .875rem;
    color:#333;
  }
  .com-input {
    width: 100%;
    height: 2rem;
    margin-top: -1px;
    border-radius: .3125rem;
    text-align: center;
    line-height: 1rem;
    border: 1px solid #f8f8f8;
    outline: 0;
  }
  .slide-fade-enter-active {
    transition: all .3s linear;
  }
  .slide-fade-leave-active {
    transition: all .3s linear;
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateY(-10px);
    opacity: 0;
  }
</style>
